import { AvailableToggleFeatures } from '@spacefill/shared/src/utils/FeatureToggling/availableToggleFeatures';

const AutomationList = async () =>
    import('../../pages/automations/List').then((module) => ({
        Component: module.AutomationList,
    }));
const OrderRouting = async () =>
    import('../../pages/automations/OrderRouting/OrderRouting').then((module) => ({
        Component: module.OrderRouting,
    }));
const OrderSyncConditions = async () =>
    import('../../pages/automations/OrderSyncConditions/OrderSyncConditions').then((module) => ({
        Component: module.OrderSyncConditions,
    }));
const StockAlerts = async () =>
    import('../../pages/automations/StockAlerts/StockAlerts').then((module) => ({
        Component: module.StockAlerts,
    }));
const AutomaticDataCompletionRulesList = async () =>
    import('../../pages/automations/AutomaticDataCompletion/RulesList').then((module) => ({
        Component: module.RulesList,
    }));

const getAutomationRoutes = (user, features) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/automations/',
            lazy: AutomationList,
        },
        {
            path: '/automations/order-routing',
            lazy: OrderRouting,
        },
        {
            path: '/automations/order-sync-conditions',
            lazy: OrderSyncConditions,
            condition: user.features?.automations?.orderIntegrationConditionsEnabled,
        },
        {
            path: '/automations/stock-alerts',
            lazy: StockAlerts,
        },
        {
            path: '/automations/automatic-data-completion/',
            lazy: AutomaticDataCompletionRulesList,
            condition: features?.[AvailableToggleFeatures.automatic_data_completion],
            conditionFailedRedirect: '/automations/',
            redirectFrom: ['/automations/automatic-data-completion'],
        },
    ];
};

export { getAutomationRoutes };
